{
  "version": 1,
  "asset_id": "dab54f67-c5dc-4d51-a892-7c7a582dd660",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/dab54f67-c5dc-4d51-a892-7c7a582dd660/cert-anvisa.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/dab54f67-c5dc-4d51-a892-7c7a582dd660/cert-anvisa.webp",
  "original_filename": "cert-anvisa.webp",
  "size": 36958,
  "content_type": "image/webp",
  "created_at": "2026-09-22T12:21:15Z"
}
